import _defineProperty from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';

var PlayIcon = function PlayIcon(props) {
  var _props$width, _props$height, _props$fill;

  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 17,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 17,
    viewBox: "0 0 17 17",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M8.5 0C3.813 0 0 3.813 0 8.5 0 13.187 3.813 17 8.5 17c4.687 0 8.5-3.813 8.5-8.5C17 3.813 13.187 0 8.5 0zm4.41 8.734l-6.234 4.25a.284.284 0 01-.443-.234v-8.5a.283.283 0 01.443-.234l6.234 4.25a.284.284 0 010 .468z",
      fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : '#5567FF'
    })
  }));
};

export default PlayIcon;